import _ from "lodash";

export const groupByKey = (arr, key) => {
  if (arr.length > 0) {
    return _.groupBy(arr, key);
  }
};
